import type { ReactNode } from "react";
import { useState } from "react";

import { TrayContext } from "./TrayContext";
import type { Placement } from "./types";

type Props = {
  show: boolean;
  active: boolean;
  placement: Placement;
  items: ReactNode[];
  children: ReactNode;
};

export const TrayContextProvider = ({ show, active, placement, items, children }: Props) => {
  const [trayItems, setTrayItems] = useState<ReactNode[]>(items);

  // note: simply to delay tray updates until next show request
  if (items !== trayItems && show) setTrayItems(items);

  return <TrayContext.Provider value={{ show, active, placement, items: trayItems }}>{children}</TrayContext.Provider>;
};
